module.exports = __webpack_public_path__ + "static/media/Pexels Videos 2469774.24d21775.mp4";